<template>
    <b-modal :id="'incompleteModal'" ref="incompleteModal" hide-header size="sm">
        <p class="m-b-xs"><strong>{{ __('invoice_number') }}:</strong> {{ document_number }}</p>
        <p class="m-b-xs">
            <strong>{{ __('document_status') }}:</strong>
            <span class="label label-danger">{{ __('not_confirmed') }}</span>

            <i v-if="getSubstatusIcon(substatus)" :class="getSubstatusIcon(substatus)"></i>

            {{ __(substatus) }}
            <span v-if="pl_ksef_information" class="text-bold" :style="pl_ksef_information_style">e </span> <span>{{pl_ksef_information_title}}</span>
        </p>
        <p class="m-b-xs"><strong>{{ __('remarks') }}:</strong> {{ remarks }} </p>
        <template #modal-footer>
            <button class="btn btn-white" type="button" @click="closeModal()">{{ __('close') }}</button>
        </template>
    </b-modal>
</template>

<script>
import events from "../../services/Events.js";

export default {
    name: "IncompleteModal",
    data: () => {
        return {
            document_number: '',
            remarks: '',
            substatus: '',
            pl_ksef_information: false,
            pl_ksef_information_style:'',
            pl_ksef_information_title:''


        }
    },
    methods: {
        getSubstatusIcon(substatus) {
            if (substatus == 'document_to_be_filled') {
                return 'fas fa-file-alt';
            } else if (substatus == 'document_to_be_split_on_employees') {
                return 'fas fa-user-check';
            } else if (substatus == 'document_to_be_split_for_controlling') {
                return 'fas fa-coins'
            }
            return null;
        },
        closeModal() {
            this.$refs.incompleteModal.hide();
        },
        openModal() {
            this.$refs.incompleteModal.show();
        }
    },
    mounted() {
        events.$on('showIncompleteModal', (document_number, remarks, substatus, pl_ksef_information, pl_ksef_information_style, pl_ksef_information_title) => {
            this.document_number = document_number;
            this.remarks = remarks;
            this.substatus = substatus;
            this.pl_ksef_information = pl_ksef_information;
            this.pl_ksef_information_style = pl_ksef_information_style;
            this.pl_ksef_information_title = pl_ksef_information_title;
            this.openModal();
        });
    }
}
</script>

<style>
.modal-sm {
    max-width: 500px !important;
}
</style>
<style scoped>
p {
    font-size: 12px;
}
</style>
